import React from 'react';

import { alpha, styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import CaseStudyIcon from '~/assets/icons/CaseStudyIcon';
import {
  PreviewTitle,
  PreviewWrapper,
  StyledCheckIcon,
  VideoPreview,
} from '~/pages/SingleVideoPage/styles';

const CaseStudyCard = ({ link, imageUrl, title, passed }) => (
  <StyledLink data-testid="caseStudyCard" to={link}>
    <PreviewWrapper>
      <VideoPreview path={imageUrl} alt="" srcset={[{ width: 120 }, { width: 80 }]} />
      {passed ? (
        <StyledCheckIcon data-testid="caseStudyCompleted" />
      ) : (
        <IconWrapper>
          <CaseStudyIcon />
        </IconWrapper>
      )}
    </PreviewWrapper>
    <PreviewTitle data-testid="cardTitle">{title}</PreviewTitle>
  </StyledLink>
);

export default CaseStudyCard;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.common.text.secondaryToPrimary};
  &:hover {
    color: ${({ theme }) => theme.palette.common.accent};
  }
`;
const IconWrapper = styled('span')`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ theme }) => alpha(theme.palette.common.blueDark, 0.7)};
`;
